<template>
  <div class="status-label" :class="['status-label--' + theme]">
    <FontAwesomeIcon v-if="icon.length" :icon="icon" size="sm" />
    {{ label }}
    <slot name="beside" />
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: 'Success',
    },
    theme: {
      type: String,
      default: 'default',
      enums: ['default', 'success', 'warning', 'error'],
    },
    icon: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss">
.status-label {
  text-align: left;
  font-size: 0.9rem;
  padding: 0.5rem 1rem;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);

  svg {
    margin-right: 0.25rem;
  }

  &--default {
    color: css-darken('border-color', 35%);
    background-color: css-alpha('border-color', 0.4);
  }

  &--success {
    color: var(--success);
    border-color: css-alpha('success', 0.2);
    background-color: css-alpha('success', 0.1);
  }

  &--warning {
    color: css-darken('warning', 5%);
    border-color: css-alpha('warning', 0.2);
    background-color: css-alpha('warning', 0.1);
  }

  &--error {
    color: css-darken('error', 5%);
    border-color: css-alpha('error', 0.2);
    background-color: css-alpha('error', 0.1);
  }
}
</style>
